import { Component } from '@verndale/core';

class Modal extends Component {
  setupDefaults() {
    this.dom = {
      triggers: document.querySelectorAll('[data-modal-trigger]'),
      close: this.el.querySelector<HTMLButtonElement>('.modal__close-btn'),
      modalContainer: this.el.querySelector<HTMLButtonElement>('.modal__inner')
    };
  }

  addListeners() {
    if ((this.dom.triggers as NodeList).length) {
      [...(this.dom.triggers as NodeList)].forEach(trigger => {
        if ((trigger as HTMLElement).dataset.modalTrigger === this.el.dataset.modalId) {
          trigger.addEventListener('click', this.openModal.bind(this));
        }
      });
    }
    (this.dom.close as HTMLButtonElement)?.addEventListener('click', this.closeModal.bind(this));
    this.el.addEventListener('click', this.handleOverlay.bind(this));

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    });
  }

  openModal() {
    (this.el as HTMLDialogElement).setAttribute('open', 'true');
    document.body.style.overflow = 'hidden';
  }

  handleOverlay(event: Event) {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.closeModal();
    }
  }

  closeModal() {
    (this.el as HTMLDialogElement).remove();
    document.body.style.overflow = 'auto';
  }
}

export default Modal;
